export default "__VITE_ASSET__MjpCKVdO__"